module.exports = __webpack_public_path__ + "img/full-avatar.eeb6851f.svg";